import MuiChip from "@mui/material/Chip";
const Chip = MuiChip;
export default Chip;
